/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useDebounce } from "react-use";
import { useGetTagsByValueLazyQuery } from "~/generated/graphql";
import { Autocomplete } from "~/components/Autocomplete";
import { DEBOUNCE_TIMEOUT_MS, FETCH_LIMIT, MINIMAL_LENGTH } from "./constants";

type Props = {
  name: string;
  onChange: (value: string) => void;
};

export function InputValue({ name, onChange }: Props) {
  const [value, setValue] = React.useState("");

  const [getTags, { data, loading }] = useGetTagsByValueLazyQuery();

  useDebounce(
    () => {
      if (value.length >= MINIMAL_LENGTH) {
        getTags({ variables: { key: name, value, limit: FETCH_LIMIT } });
      }
    },
    DEBOUNCE_TIMEOUT_MS,
    [value]
  );

  const proposed = data?.searchTagValues?.values ?? [];

  return (
    <Autocomplete
      label="Tag Value"
      id="tag-value"
      items={proposed}
      loading={loading}
      onChange={(newValue) => {
        setValue(newValue);
        onChange(newValue);
      }}
      onSelect={onChange}
      value={value}
    />
  );
}
